import { Request } from '@/classes/Request'

// POST /ajax/enrollment/submit
export const postEnrollment = async (
  programSubgroupId: number,
  selectedStudentAccountId: number | null,
  formSubmissionIds: any,
  slotIds: number[],
  // DTA-1092: the plan chosen before picking days, when the subgroup asks
  planChoice: { type: string; id: number } | null = null
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post('/ajax/enrollment/submit', {
        program_subgroup_id: programSubgroupId,
        student_account_id: selectedStudentAccountId,
        form_submission_ids: formSubmissionIds,
        slot_ids: slotIds,
        ...(planChoice ? { plan_choice: planChoice } : {})
      })
      .then((response: any) => {
        resolve({
          contractRevisionId: response.contract_revision_id,
          assignedFeeIds: response.assigned_fee_ids,
          // DTA-966: the enrollment waits for payment and is submitted once it is paid
          requiresPayment: response.requires_payment === true
        })
      })
      .catch((err: any) => {
        // DTA-880: carry the server's plain reason (e.g. a session dated today or
        // earlier) so the family sees why, not just that it failed.
        reject({
          reason: err?.response?.data?.failure_reason ?? null,
          message:
            'Failed to submit enrollment: ' +
            (err?.response?.data?.failure_reason ?? err?.message ?? ''),
          cause: err
        })
      })
  })
}
